"use client";

export default function SinMatchLeagues({ league, matches = [], render = () => null }) {
  const leagueName = league?.nameVN || league?.name || "Giải đấu";
  const leagueLogo = league?.logo || league?.leagueLogo;

  return (
    <section className="kbv-sin-league-block overflow-hidden rounded-lg bg-[var(--theme-foreground)]">
      <div className="kbv-sin-league-head flex items-center gap-1.5 rounded-t-lg px-2 py-1">
        {leagueLogo ? (
          <img
            src={leagueLogo}
            alt=""
            className="h-4 w-4 shrink-0 object-contain"
            width={16}
            height={16}
            loading="lazy"
          />
        ) : null}
        <h3 className="min-w-0 flex-1 truncate text-[13px] font-semibold leading-tight text-[var(--theme-text)]">
          {leagueName}
        </h3>
      </div>
      <div className="kbv-sin-league-body">
        {matches.map((match, idx) => (
          <div key={match?.id || idx}>{render(match, idx)}</div>
        ))}
      </div>
    </section>
  );
}
